import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAsyncValue, useNavigate } from 'react-router-dom';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

// Components
import BudgetItemsForm from '../../../../../components/forms/ActionForms/BudgetItemsForm';

// Types
import { BudgetItemsFormValues } from '../../../../../components/forms/ActionForms/BudgetItemsForm/types';
import { OrderType } from '../../../../../types/orders';
import { Role } from '../../../../../types/auth';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

// Utils
import { roleCanViewBudgets } from '../../../../../utils/rolePermissions';

export default function BudgetItemsFormPage(): JSX.Element | null {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as BudgetItemsFormValues;
  const { user } = useAuth();
  const currentRole = user?.user?.rolActive;
  const skipBudgets =
    currentRole === Role.Tablet || !roleCanViewBudgets(currentRole);

  // Redirigir a Tablets y roles ciegos a budgets (capataz) al siguiente paso
  useLayoutEffect(() => {
    if (skipBudgets) {
      navigate('../materials', { replace: true });
      return;
    }

    dispatch(
      roidOTSelected(
        OrderType.Action,
        loaderData.breadCrumbsData.orderParentRoid,
        loaderData.breadCrumbsData.orderParentId
      )
    );
  }, [user, navigate, dispatch, loaderData]);

  const onFormSubmit = () => {
    navigate('../materials');
  };

  // No renderizar para Tablets ni roles ciegos a budgets (capataz)
  if (skipBudgets) {
    return null;
  }

  return (
    <BudgetItemsForm
      onFormSubmit={onFormSubmit}
      initialData={loaderData}
      sessionStorageKey={formActionNaming.NEW_BUDGET_ITEMS_FORM}
      textButton={t('buttons:next')}
    />
  );
}
